import React, { useState, useEffect } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import VideoModal from '../../../v2/MUI_custom_component/Modal/VideoModal';
import IconReusable from '../../../components/IconReusable';
const TestimonialVideoModal = ({
  open,
  onClose,
  videos = [],
  selectedVideoIndex = 0,
  videoRef,
  currentTime = 0,
  duration = 0,
  onSeek,
  onTimeUpdate,
  onVideoClick,
  onEnded,
  videoError = false,
  modalSx = {}
}) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const selectedVideo = videos[selectedVideoIndex];

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play()
          .then(() => setIsPlaying(true))
          .catch(e => console.log('Play failed:', e));
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  // Reset playing state when video changes
  useEffect(() => {
    setIsPlaying(true);
  }, [selectedVideoIndex]);
  
  if (!selectedVideo) {
    return null;
  }

  const defaultModalSx = {
    p: 0,
    height: '100vh',
    ...modalSx
  };

  return (
    <VideoModal
      open={open}
      onClose={onClose}
      currentTime={currentTime}
      duration={duration}
      onSeek={onSeek}
      sx={defaultModalSx}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ 
          position: 'relative',  
          borderRadius: 2,
          '&:hover .play-pause-overlay': {
            opacity: 1,
          }
        }}>
          {!videoError ? (
            <Box
              ref={videoRef}
              component="video"
              src={selectedVideo.link}
              poster={selectedVideo.thumbnail}
              autoPlay
            //   muted
              preload="auto"
              playsInline
              webkit-playsinline="true"
              crossOrigin="anonymous"
              onClick={handlePlayPause}
              onTimeUpdate={onTimeUpdate}
              onEnded={onEnded}
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              sx={{
                width: '100%',
                height: {xs: 'auto', md:'70vh'},
                objectFit: 'cover',
                borderRadius: 2,
                cursor: 'pointer',
              }}
            />
            ) : (
              <Box
                sx={{
                  width: '100%',
                  height: '80vh',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: '#000',
                  borderRadius: 2,
                  color: '#FFF',
                }}
              >
                <Typography>Video could not be loaded</Typography>
              </Box>
            )
          }
        </Box>
        
        <Box 
          key={selectedVideoIndex}
          sx={{ 
            display: 'flex', 
            gap: 0.5,
            flexDirection: 'column',
            transition: 'opacity 0.3s ease-in-out',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h2" sx={{ color: '#FFF' }}>
              {selectedVideo.name}
            </Typography>
            <Box sx={{ width: '1px', height: '24px', backgroundColor: '#FFF' }} />
            <Typography variant="LabelD" sx={{ color: '#FFF', textAlign: 'end' }}>
              {selectedVideo.place}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Typography variant="LabelD" sx={{ color: '#FFF' }}>
              {selectedVideo.role}
            </Typography>
          </Box>
        </Box>
      </Box>
    </VideoModal>
  );
};

export default TestimonialVideoModal;